import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBackIosNewOutlinedIcon } from 'icons/materialIcons';

const TeamAddMemberHeader = ({ onBack }) => {
    return (
        <Box sx={{ marginBottom: '2rem', paddingLeft: '0' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    onClick={onBack}
                    sx={{
                        backgroundColor: 'transparent',
                        color: '#828282',
                        padding: 0,
                        marginRight: '1rem',
                        '& .MuiSvgIcon-root': {
                            fontSize: '1rem',
                        },
                    }}
                >
                    <ArrowBackIosNewOutlinedIcon />
                </IconButton>
                <Box
                    sx={{
                        height: 25,
                        width: '1px',
                        backgroundColor: '#e0e0e0',
                        marginRight: '1rem',
                    }}
                />
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 500,
                        color: '#333',
                    }}
                >
                    Add a Member
                </Typography>
            </Box>
        </Box>
    );
};

export default TeamAddMemberHeader;

